import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchListItems } from '../../../../../hooks/useCrud';
import LoaderAndError from '../../../../../components/LoaderAndError';
import { fileUrl } from '../../../../../api/config';

interface UiSecteur {
    id?: number;
    nomSecteur?: string;
}


interface UiBlog {
    id?: number;
    titre?: string;
    soustitre?: string;
    description?: string;
    idSecteur?: number;
    icone?: string;
    logoFile?: File;
    slug?: String;

    annee?: string;
    budget?: string;
    organisation?: string;

    createdAt?: string;
    updatedAt?: string;
    // jointire
    secteur_projet?: UiSecteur;

}

export default function Projet() {

    const [projects, setProject] = useState<UiBlog[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);



    const fetchListCategorie = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiBlog>('/fetch_projet_data');
            setProject(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchListCategorie();
    }, []);
    return (
        <div className="container py-5">
            {/* Header */}
            <div className="text-center mb-5">
                <h2 className="fw-bold display-10">
                    Nos <span className="text-primary">Projets Clés</span>
                </h2>
                <p className="text-muted fs-5">
                    Des projets innovants et structurants pour répondre aux besoins de nos communautés.
                </p>
            </div>

            <div className="row g-4">
                {projects.length === 0 ? (
                    <LoaderAndError
                        loading={loading}
                        error={error}
                        onClearError={() => setError(null)}
                    />
                ) : (
                    projects.map((item) => (
                        <div className="col-md-6 col-lg-6" key={item.id}>
                            <div
                                className="
                            project-card shadow-sm rounded-4 border-0 h-100 
                            overflow-hidden bg-white dark:bg-gray-900
                            transition-all duration-300 hover:shadow-xl hover:-translate-y-1
                        "
                            >

                                {/* IMAGE */}
                                <div className="position-relative overflow-hidden" style={{ height: "260px" }}>
                                    <img
                                        src={fileUrl + '/images/' + item.icone}
                                        alt={item.titre}
                                        className="
                                            img-fluid w-100 h-100 object-cover 
                                            project-img transition-transform duration-500
                                        "
                                    />

                                    {/* BADGE SECTEUR */}
                                    <div className="position-absolute top-0 end-0 m-3">
                                        <span
                                            className="
                                                badge px-3 py-2 rounded-pill 
                                                bg-info bg-opacity-90 text-white fw-semibold shadow
                                            "
                                        >
                                            <i className="fas fa-tag me-2"></i>
                                            {item.secteur_projet?.nomSecteur}
                                        </span>
                                    </div>

                                    {/* OVERLAY */}
                                    <div
                                        className="
                                            position-absolute bottom-0 start-0 end-0 p-3 
                                            bg-gradient-to-t from-black/70 to-transparent text-white
                                        "
                                    >
                                        <h3 className="h5 fw-bold mb-0 text-white">{item.titre}</h3>
                                    </div>
                                </div>

                                {/* BODY */}
                                <div className="card-body py-3">
                                    <p className="text-muted mb-3 text-truncate-3">
                                        {item.soustitre}
                                    </p>

                                    {/* Informations supplémentaires */}
                                    <ul className="list-unstyled small text-muted">
                                        {item.annee && <li><i className="fas fa-calendar me-2"></i> Année : {item.annee}</li>}
                                        {item.budget && <li><i className="fas fa-wallet me-2"></i> Budget : {item.budget}</li>}
                                        {item.organisation && <li><i className="fas fa-building me-2"></i> Organisation : {item.organisation}</li>}
                                    </ul>
                                </div>

                                {/* CTA */}
                                <div className="card-footer bg-transparent border-0 pb-4 px-4">
                                    <Link
                                        to={`/project/${item.slug}`}
                                        className="
                                            btn btn-primary btn-sm w-100 rounded-pill py-2 fw-semibold 
                                            d-flex justify-content-center align-items-center gap-2
                                            shadow-sm hover-shadow-lg transition-all
                                        "
                                    >
                                        Découvrir
                                        <i className="fas fa-arrow-right"></i>
                                    </Link>
                                </div>

                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>

    )
}
